module.exports = __webpack_public_path__ + "static/media/pass2.6f3c8668.png";